/**
 * Runtime configuration
 * Reads from window.RUNTIME_CONFIG (injected at container startup) with fallback to build-time env
 *
 * In development: manually create public/runtime-config.js from the example file
 * In production: entrypoint.sh generates runtime-config.js from env vars at container start
 */

import type { RuntimeConfig } from "@/types/runtime-config";
import { Environment } from "@/types/runtime-config";

const getRuntimeConfig = (): RuntimeConfig => {
  return window.RUNTIME_CONFIG || {};
};

export const config = {
  get agreementBackendUrl() {
    const runtimeConfig = getRuntimeConfig();
    return (
      runtimeConfig.AGREEMENT_BACKEND_URL || import.meta.env.VITE_AGREEMENT_BACKEND_BASE_URL || ""
    );
  },
  get hotelsOrgId() {
    const runtimeConfig = getRuntimeConfig();
    return runtimeConfig.HOTELS_ORG_ID || import.meta.env.VITE_HOTELS_ORG_ID || "";
  },
  get bristolOrgId() {
    const runtimeConfig = getRuntimeConfig();
    return runtimeConfig.BRISTOL_ORG_ID || import.meta.env.VITE_BRISTOL_ORG_ID || "";
  },
  get flexOrgId() {
    const runtimeConfig = getRuntimeConfig();
    return runtimeConfig.FLEX_ORG_ID || import.meta.env.VITE_FLEX_ORG_ID || "";
  },
  get environment(): Environment {
    const runtimeConfig = getRuntimeConfig();
    return (
      runtimeConfig.ENVIRONMENT ||
      (import.meta.env.VITE_ENVIRONMENT as Environment | undefined) ||
      Environment.Prod
    );
  },
  get frontendBaseUrl() {
    const runtimeConfig = getRuntimeConfig();
    return runtimeConfig.FRONTEND_BASE_URL || import.meta.env.VITE_FRONTEND_BASE_URL || "";
  },
  get runtimeConfig() {
    return getRuntimeConfig();
  },
};
